import { render } from "./PreferredMethods.vue?vue&type=template&id=2eb5b874&lang=pug"
import script from "./PreferredMethods.vue?vue&type=script&lang=js"
export * from "./PreferredMethods.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__